<button type="button" class="btn-action btn-right" (click)="open($event)">
  <span class="icon material-symbols-outlined arrow-right-flex-grow"> {{ icon }} </span>
</button>
